
import api from '@/api';
import DataTableComponent from '@/components/DataTableComponent.vue';
import { cobrancaStore, mainStore } from '@/store';
import { isEqual } from 'date-fns';
import _ from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    DataTableComponent,
  },
})
export default class FinanceiroList extends Vue {
  @Prop({ type: Number }) readonly propC014_id;

  @Watch('propC014_id')
  async onChangeC014_id(val: number) {
    this.c014_id = val;
    await this.load;
  }

  public tiposFatura = 'emAberto';
  public isLoading = true;
  public totalDevido = 0;
  public qtdTitulosVencidos = 0;
  public c014_id = 0;
  public search = '';

  public today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

  public headers = [
    {
      text: 'Nº Título',
      sortable: true,
      value: 'Documento',
      align: 'left',
    },
    {
      text: 'Vencimento',
      sortable: true,
      value: 'T014_Vencimento',
      align: 'left',
    },
    {
      text: 'Tipo',
      sortable: true,
      value: 'Tipo',
      align: 'left',
    },
    {
      text: 'Tipo Baixa',
      sortable: true,
      value: 'descricao',
      align: 'left',
    },
    {
      text: 'Valor original',
      sortable: true,
      value: 'valor_original',
      align: 'left',
    },
    {
      text: 'Valor atualizado',
      sortable: true,
      value: 'valor_atualizado',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'center',
    },
  ];

  public headersFinanceiro = [
    {
      text: 'Nº Título',
      sortable: true,
      value: 'Documento',
      align: 'left',
    },
    {
      text: 'Vencimento',
      sortable: true,
      value: 'T014_Vencimento',
      align: 'left',
    },
    {
      text: 'Data pagamento',
      sortable: true,
      value: 'T014_DataPagamento',
      align: 'left',
    },
    {
      text: 'Tipo',
      sortable: true,
      value: 'Tipo',
      align: 'left',
    },
    {
      text: 'Tipo Baixa',
      sortable: true,
      value: 'descricao',
      align: 'left',
    },
    {
      text: 'Valor original',
      sortable: true,
      value: 'valor_original',
      align: 'left',
    },
    {
      text: 'Valor atualizado',
      sortable: true,
      value: 'valor_atualizado',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'center',
    },
  ];

  get details() {
    return cobrancaStore.cobrancaDetails;
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  get getHeader() {
    if (!this.userProfile) return;

    if (this.userProfile.is_superuser || this.userProfile.departure_id === 11) return this.headersFinanceiro;

    return this.headers;
  }

  get tituloItems() {
    let array = [];
    let titulosVencidos = [];

    //@ts-ignore
    if (!this.details.titulos || !this.details.titulos) return array;
    if (this.tiposFatura === 'emAberto') this.qtdTitulosVencidos = 0;

    //@ts-ignore
    for (const a in this.details.titulos) {
      if (this.tiposFatura === 'emAberto') {
        //@ts-ignore
        const item = this.details.titulos[a];
        item['data_vencimento'] = '';
        if (item.valor_original && !item.valor_atualizado && item.valor_original !== item.valor_pago) {
          //@ts-ignore
          array.push(item);
        } else if (!item.valor_pago || (item['valor_atualizado'] && item['valor_pago'] && item.valor_atualizado > 0)) {
          //item['valor_atualizado'] && item['valor_pago']"
          if (new Date(item.T014_Vencimento) < this.today) {
            if (isEqual(new Date(item.T014_Vencimento), this.today)) {
              item['valor_atualizado'] = item.valor_original;
            }
            item['data_vencimento'] = 'vencido';

            this.qtdTitulosVencidos += 1;
            //@ts-ignore
            titulosVencidos.push(item);
          }

          //@ts-ignore
          array.push(item);
        }
      } else {
        //@ts-ignore
        const item = this.details.titulos[a];
        item['data_vencimento'] = '';

        if (item.valor_pago >= item['valor_original']) {
          if (new Date(item.T014_Vencimento) < this.today) {
            item['data_vencimento'] = 'vencido';
          }
          //@ts-ignore
          array.push(item);
        }
      }
    }

    // SOMA VALOR TOTAL DEVIDO E ATRASADO
    this.totalDevido = _.sum(_.map(titulosVencidos, (t) => _.toNumber(t.valor_atualizado)));

    if (this.tiposFatura === 'emAberto') return _.orderBy(array, ['T014_Vencimento'], ['asc']);
    else return _.orderBy(array, ['T014_Vencimento'], ['desc']);
  }

  public async baixarBoleto(item) {
    try {
      const response = await api.getCompanyBoletos(mainStore.token, item);
      if (response) {
        const bytes = response.data;

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', `${item.Documento}.pdf`);
        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setTimeout(() => {
          window.URL.revokeObjectURL(blobURL);
        }, 100);
      }
    } catch (e) {
      await mainStore.checkApiError(<any>e);
    }
  }

  public async getCodigoBoleto(id) {
    const loadingNotification = { content: 'Copiando', showProgress: true };
    try {
      mainStore.addNotification(loadingNotification);
      const response = await api.getCodigoBoleto(mainStore.token, id);
      if (response) {
        navigator.clipboard.writeText(response.data);
        mainStore.removeNotification(loadingNotification);
        mainStore.addNotification({
          content: 'Código copiado com sucesso',
          color: 'success',
        });
      }
    } catch (error) {
      mainStore.removeNotification(loadingNotification);
      mainStore.addNotification({
        content: 'Ocorreu um erro ao copiar o código',
        color: 'error',
      });
      await mainStore.checkApiError(<any>error);
    }
  }

  public titleCase(txt: string) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }

  public async load() {
    this.isLoading = true;

    if (!this.userProfile) return;

    if (this.propC014_id) {
      await cobrancaStore.getCobrancaDetails(this.propC014_id);
    } else {
      const c014_id = this.userProfile.company.c014_id;

      await cobrancaStore.getCobrancaDetails(c014_id);
    }

    this.isLoading = false;
  }

  public async mounted() {
    await this.load();
  }
}
